import { memo, type ReactNode } from 'react';

import { SettingsIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';
import { Popover } from '@air/primitive-popover';

export type ViewVisibilityToggleMenuProps = {
  children: ReactNode;
};

export const ViewVisibilityToggleMenu = memo(({ children }: ViewVisibilityToggleMenuProps) => {
  return (
    <Popover
      side="bottom"
      align="end"
      size="large"
      // The redesign gives the popover a hairline frame and a larger radius; class twins keep flag-off unchanged.
      className="ui2026:rounded-8 ui2026:border ads:border-default ui2026:border-gray-4 ads:bg-base ui2026:bg-gray-1"
      trigger={
        <IconButton
          appearance="ghost"
          color="gray"
          size="small"
          label="Visibility Toggles"
          data-testid="CONFIG_VIEWS_VISIBILITY"
          adsIcon
          icon={SettingsIcon}
        />
      }
    >
      {children}
    </Popover>
  );
});

ViewVisibilityToggleMenu.displayName = 'ViewVisibilityToggleMenu';
